import {NavigationPageEnum, NavigationPageEnumHumanReadable} from '../../navigations.enums';
import {IUserAccessFeature} from '../user-access-features';
import {SettingsReferenceEnum} from '../../../../settings-new/models';

//#region INTERFACE IFeatureStockManager
export interface IFeatureStockManager extends IUserAccessFeature, Object {
}

//#endregion

//#region CONST _FEATURE_STOCK_MANAGER_DEFAULT
export const _FEATURE_STOCK_MANAGER_DEFAULT: Readonly<IFeatureStockManager & Object> = {
  displayText: NavigationPageEnumHumanReadable.StockManager,
  feature: NavigationPageEnum.StockManager,
  ref: SettingsReferenceEnum.undefined,
  standalone: false,
};
//#endregion